/** @file ArtModal: a centred dialog box over the Art screen with a dimmed backdrop. */
import type { ReactElement, ReactNode } from 'react';

/** The dialog's accessible name, its content, and `wide` for a dialog showing images side by side. */
export type ArtModalProps = { label: string; children: ReactNode; wide?: boolean };

/** `role="dialog"` over a fixed backdrop; the content owns its buttons. */
export function ArtModal({ label, children, wide = false }: ArtModalProps): ReactElement {
  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 20, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(8,9,12,0.6)' }}>
      <div role="dialog" aria-label={label} style={{ display: 'flex', flexDirection: 'column', gap: 10, minWidth: 320, maxWidth: wide ? 'min(1100px, 94vw)' : 520, maxHeight: wide ? '92vh' : '70vh', padding: 16, borderRadius: 8, border: '1px solid #44474f', background: '#25282f', color: '#e6e8ec', fontSize: 12 }}>
        {children}
      </div>
    </div>
  );
}
